import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

/**
 * Mono chip for actions/resources/IDs (design §4: `font-mono text-xs`,
 * `bg-muted rounded-sm px-1.5 py-0.5`). Rendered as `<code>` (§22).
 */
export function MonoChip({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <code
      className={cn(
        'break-all rounded-sm bg-muted px-1.5 py-0.5 font-mono text-xs text-muted-foreground',
        className,
      )}
    >
      {children}
    </code>
  );
}
